import React from 'react';
import { Box, Button, Flex, Text } from 'pcln-design-system';
/** @public */
var SignUpComplete = function (_a) {
  var closeToast = _a.closeToast,
    headline = _a.headline,
    _b = _a.isCloseButtonShown,
    isCloseButtonShown = _b === void 0 ? false : _b,
    subheadline = _a.subheadline;
  return React.createElement(Flex, {
    alignItems: 'center',
    flexDirection: ['column', null, null, 'row'],
    textAlign: ['center', null, null, isCloseButtonShown ? 'left' : 'center'],
    justifyContent: ['center', null, null, isCloseButtonShown ? 'space-between' : 'center'],
    p: [2, null, null, 4],
    width: 1
  }, React.createElement(Box, null, React.createElement(Text, {
    color: 'text.base',
    fontWeight: 'bold',
    fontSize: 3,
    m: 0
  }, headline), React.createElement(Text, {
    color: 'text.light',
    fontSize: 1,
    mt: 1
  }, subheadline)), isCloseButtonShown && React.createElement(Flex, {
    justifyContent: 'center',
    ml: [0, null, null, 3],
    mt: [3, null, null, 0],
    width: [1, null, null, 'auto']
  }, React.createElement(Button, {
    variation: 'subtle',
    width: [1, null, null, 'auto'],
    onClick: closeToast
  }, "Close")));
};
export default SignUpComplete;